import { HttpErrorResponse } from '@angular/common/http'
import { Update } from '@ngrx/entity'
import { createAction, props } from '@ngrx/store'
import { ProjectorTemplatesEntity } from './projector-templates.models'

export const loadProjectorTemplates = createAction('[ProjectorTemplates Page] Load Projector Templates')

export const loadProjectorTemplatesSuccess = createAction(
  '[ProjectorTemplates/API] Load Projector Templates Success',
  props<{ templates: ProjectorTemplatesEntity[] }>(),
)

export const loadProjectorTemplatesFailure = createAction(
  '[ProjectorTemplates/API] Load Projector Templates Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const loadProjectorTemplate = createAction(
  '[ProjectorTemplates Page] Load Projector Template',
  props<{ uuid: string }>(),
)

export const loadProjectorTemplateSuccess = createAction(
  '[ProjectorTemplates/API] Load Projector Template Success',
  props<{ template: ProjectorTemplatesEntity }>(),
)

export const loadProjectorTemplateFailure = createAction(
  '[ProjectorTemplates/API] Load Projector Template Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const selectProjectorTemplate = createAction(
  '[ProjectorTemplates Page] Select Projector Template',
  props<{ uuid: string }>(),
)

export const clearSelectedProjectorTemplate = createAction(
  '[ProjectorTemplates Page] Clear Selected Projector Template',
)

export const updateProjectorTemplate = createAction(
  '[ProjectorTemplates Page] Update Projector Template',
  props<{ template?: Partial<ProjectorTemplatesEntity>; updateConfig: boolean }>(),
)

export const updateProjectorTemplateSuccess = createAction(
  '[ProjectorTemplates/API] Update Projector Template Success',
  props<{ update: Update<ProjectorTemplatesEntity> }>(),
)

export const updateProjectorTemplateFailure = createAction(
  '[ProjectorTemplates/API] Update Projector Template Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openProjectorTemplateConfigDialog = createAction('[Projector/Page] Open Projector Template Config')

export const initSelectedProjectorTemplate = createAction('[ProjectorTemplates/Page] Initialise Projector Template')

export const openSaveProjectorAsTemplateDialog = createAction(
  '[PresenterPreview/Page] Open Save Projector As Template Dialog',
  props<{ projectorUuid: string }>(),
)

export const saveProjectorAsTemplate = createAction(
  '[ProjectorTemplates/API] Save Projector As Template',
  props<{
    projectorUuid: string
    name: string
    description: string
    is_public_all_client_accounts: boolean
    client_accounts: string[]
  }>(),
)

export const saveProjectorAsTemplateSuccess = createAction(
  '[ProjectorTemplates/API] Save Projector As Template Success',
  props<{ template: ProjectorTemplatesEntity }>(),
)

export const saveProjectorAsTemplateFailure = createAction(
  '[ProjectorTemplates/API] Save Projector As Template Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const saveTemplate = createAction(
  '[ProjectorTemplates/API] Save template',
  props<{ template: Partial<ProjectorTemplatesEntity> & Pick<ProjectorTemplatesEntity, 'uuid'> }>(),
)

export const createProjectorTemplate = createAction(
  '[ProjectorTemplates/API] Create Projector Template',
  props<{ template: Partial<ProjectorTemplatesEntity> }>(),
)

export const createProjectorTemplateSuccess = createAction(
  '[ProjectorTemplates/API] Create Projector Template Success',
  props<{ template: ProjectorTemplatesEntity }>(),
)

export const createProjectorTemplateFailure = createAction(
  '[ProjectorTemplates/API] Create Projector Template Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const goToPresenterTemplate = createAction(
  '[ProjectorTemplates/Page] Go to presenter Template',
  props<{ uuid: string }>(),
)

export const applySelectedTemplateToSelectedSlide = createAction(
  '[ProjectorTemplates/Page] Apply Selected Template To Selected Slide',
)

export const applySelectedTemplateToSelectedSlideSuccess = createAction(
  '[ProjectorTemplates/API] Apply Selected Template To Selected Slide Success',
)

export const applySelectedTemplateToSelectedSlideFailure = createAction(
  '[ProjectorTemplates/API] Apply Selected Template To Selected Slide Failure',
  props<{ error: HttpErrorResponse }>(),
)
